import React from "react";

export default function Privacy() {
  return (
    <div data-testid="privacy-page" className="bg-[#FAFAF7]">
      <section className="mx-auto max-w-[900px] px-5 lg:px-10 pt-16 pb-8">
        <div className="text-xs font-bold uppercase tracking-[0.25em] text-[#FF5A1F] mb-4">— Privacy Policy</div>
        <h1 className="font-display text-5xl md:text-7xl uppercase leading-[0.9] text-[#0A0A0A]">
          Privacy Policy
        </h1>
        <p className="mt-6 text-sm text-[#0A0A0A]/60">
          Informativa sul trattamento dei dati personali ai sensi dell'art. 13 del Regolamento (UE) 2016/679
        </p>
        <p className="mt-2 text-xs uppercase tracking-widest text-[#0A0A0A]/50">
          Ultimo aggiornamento: 31.07.2026
        </p>
      </section>

      <section className="mx-auto max-w-[900px] px-5 lg:px-10 pb-24 legal-doc">
        <p>
          La presente informativa descrive le modalità con cui <strong>Perla Music</strong> tratta i dati personali degli utenti che consultano il sito e utilizzano i relativi servizi.
        </p>

        <h2>1. Titolare del trattamento</h2>
        <p>
          Il Titolare del trattamento è <strong>Perla Music Ditta Individuale</strong>, in persona del legale rappresentante <strong>Alessio Dell'Armellina</strong>, con sede legale in Via Binda 8/A, Besozzo (VA), P.IVA 04040350128, REA n. 402963, PEC: <a href="mailto:alessiodallarmellina@pec.it">alessiodallarmellina@pec.it</a>.
        </p>
        <p>
          Il Titolare può essere contattato per richieste relative al trattamento dei dati personali e per l'esercizio dei diritti riconosciuti dalla normativa applicabile.
        </p>

        <h2>2. Categorie di dati trattati</h2>

        <h3>2.1 Dati di navigazione</h3>
        <p>
          I sistemi informatici utilizzati per il funzionamento del sito acquisiscono dati tecnici connessi all'uso dei protocolli Internet, quali indirizzo IP, tipo di dispositivo e browser, sistema operativo, data e ora delle richieste, pagine visitate, informazioni tecniche e log di sicurezza.
        </p>

        <h3>2.2 Dati forniti mediante il modulo di contatto</h3>
        <p>
          Il modulo di contatto può raccogliere nome, indirizzo e-mail, numero di telefono, contenuto del messaggio ed eventuali ulteriori informazioni inserite volontariamente dall'utente.
        </p>

        <h3>2.3 Dati forniti mediante il modulo di candidatura</h3>
        <p>
          Il modulo di candidatura può raccogliere: nome dell'artista o nome e cognome; indirizzo e-mail e numero di telefono; genere musicale, regione e obiettivi professionali; numero indicativo di ascoltatori Spotify e budget dichiarato; profilo Instagram e altri collegamenti professionali; contenuto del messaggio e ulteriori informazioni fornite spontaneamente; eventuali materiali, demo, fotografie, curriculum, portfolio o collegamenti trasmessi dall'interessato, se previsti dal modulo.
        </p>
        <p>
          L'interessato è invitato a comunicare esclusivamente informazioni pertinenti alla candidatura e a non inserire dati particolari non necessari, relativi, ad esempio, alla salute, alle convinzioni religiose o politiche o ad altri aspetti della vita privata estranei alla valutazione professionale.
        </p>

        <h3>2.4 Dati relativi alla provenienza della richiesta</h3>
        <p>
          Le landing page possono acquisire parametri UTM e informazioni sulla provenienza del contatto, quali source, campaign, medium, ad, adset, content, term e platform. Tali informazioni possono essere associate alla richiesta o alla candidatura per misurare l'efficacia delle campagne e ricostruire il canale di provenienza del lead.
        </p>

        <h3>2.5 Dati relativi alle preferenze commerciali</h3>
        <p>
          Quando l'utente presta il consenso, il Titolare tratta i dati di contatto e le informazioni necessarie a documentare la scelta effettuata, quali data, ora, modalità di acquisizione e stato del consenso, per l'invio di comunicazioni promozionali e commerciali.
        </p>

        <h2>3. Finalità, basi giuridiche e periodi di conservazione</h2>
        <div className="overflow-x-auto my-6">
          <table className="w-full border-collapse border-2 border-[#0A0A0A] text-sm">
            <thead className="bg-[#F2F2EC]">
              <tr>
                <th className="border-2 border-[#0A0A0A] p-3 text-left">Finalità</th>
                <th className="border-2 border-[#0A0A0A] p-3 text-left">Descrizione</th>
                <th className="border-2 border-[#0A0A0A] p-3 text-left">Base giuridica</th>
                <th className="border-2 border-[#0A0A0A] p-3 text-left">Conservazione</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border-2 border-[#0A0A0A] p-3">Funzionamento e sicurezza del sito</td>
                <td className="border-2 border-[#0A0A0A] p-3">Consentire la navigazione, prevenire abusi, rilevare malfunzionamenti e tutelare i sistemi.</td>
                <td className="border-2 border-[#0A0A0A] p-3">Legittimo interesse del Titolare, art. 6, par. 1, lett. f), GDPR.</td>
                <td className="border-2 border-[#0A0A0A] p-3">Log tecnici: di regola fino a 6 mesi, salvo esigenze di sicurezza o accertamento di illeciti.</td>
              </tr>
              <tr>
                <td className="border-2 border-[#0A0A0A] p-3">Gestione delle richieste di contatto</td>
                <td className="border-2 border-[#0A0A0A] p-3">Rispondere alle richieste, fornire informazioni e predisporre eventuali rapporti richiesti dall'utente.</td>
                <td className="border-2 border-[#0A0A0A] p-3">Esecuzione di misure precontrattuali, art. 6, par. 1, lett. b), GDPR.</td>
                <td className="border-2 border-[#0A0A0A] p-3">Fino a 12 mesi dalla conclusione della gestione, salvo instaurazione di un rapporto o tutela di diritti.</td>
              </tr>
              <tr>
                <td className="border-2 border-[#0A0A0A] p-3">Valutazione della candidatura</td>
                <td className="border-2 border-[#0A0A0A] p-3">Esaminare il profilo, contattare il candidato, organizzare colloqui o valutazioni e formulare eventuali proposte di collaborazione o rappresentanza.</td>
                <td className="border-2 border-[#0A0A0A] p-3">Esecuzione di misure precontrattuali, art. 6, par. 1, lett. b), GDPR.</td>
                <td className="border-2 border-[#0A0A0A] p-3">Fino a 12 mesi dalla candidatura, salvo prosecuzione del rapporto o richiesta anticipata di cancellazione.</td>
              </tr>
              <tr>
                <td className="border-2 border-[#0A0A0A] p-3">Future opportunità artistiche o professionali</td>
                <td className="border-2 border-[#0A0A0A] p-3">Conservare il profilo e ricontattare l'interessato per successive opportunità coerenti con la candidatura, anche diverse da quella inizialmente valutata.</td>
                <td className="border-2 border-[#0A0A0A] p-3">Consenso facoltativo, art. 6, par. 1, lett. a), GDPR.</td>
                <td className="border-2 border-[#0A0A0A] p-3">Fino a 24 mesi dal consenso, salvo revoca anticipata; al termine il consenso potrà essere richiesto nuovamente.</td>
              </tr>
              <tr>
                <td className="border-2 border-[#0A0A0A] p-3">Marketing e comunicazioni commerciali</td>
                <td className="border-2 border-[#0A0A0A] p-3">Inviare, tramite e-mail o contatto telefonico, newsletter, offerte, promozioni, eventi, iniziative e comunicazioni relative ai servizi del Titolare.</td>
                <td className="border-2 border-[#0A0A0A] p-3">Consenso facoltativo, art. 6, par. 1, lett. a), GDPR e art. 130 del D.Lgs. 196/2003.</td>
                <td className="border-2 border-[#0A0A0A] p-3">Fino alla revoca e comunque per non oltre 24 mesi dall'ultima interazione significativa, salvo rinnovo del consenso.</td>
              </tr>
              <tr>
                <td className="border-2 border-[#0A0A0A] p-3">Adempimenti legali e tutela dei diritti</td>
                <td className="border-2 border-[#0A0A0A] p-3">Adempiere a obblighi di legge, rispondere alle autorità e accertare, esercitare o difendere un diritto.</td>
                <td className="border-2 border-[#0A0A0A] p-3">Obbligo legale, art. 6, par. 1, lett. c), GDPR; legittimo interesse, art. 6, par. 1, lett. f), GDPR.</td>
                <td className="border-2 border-[#0A0A0A] p-3">Per il periodo previsto dalla legge o necessario alla tutela del diritto.</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p>
          I parametri UTM sono conservati per lo stesso periodo della richiesta o della candidatura cui risultano associati.
        </p>
        <p>
          Il consenso alle future opportunità professionali e il consenso al marketing costituiscono finalità distinte. Il rifiuto o la revoca di tali consensi non pregiudicano la valutazione della candidatura già presentata.
        </p>

        <h2>4. Natura del conferimento</h2>
        <p>
          Il conferimento dei dati contrassegnati come obbligatori nei moduli è necessario per consentire al Titolare di gestire la richiesta o valutare la candidatura. Il mancato conferimento può impedire l'invio del modulo o la relativa gestione.
        </p>
        <p>
          Il conferimento dei dati per ricevere future opportunità professionali e comunicazioni commerciali è facoltativo. Le relative caselle non devono essere preselezionate e il consenso può essere revocato in qualsiasi momento senza conseguenze sulla candidatura.
        </p>

        <h2>5. Modalità del trattamento</h2>
        <p>
          Il trattamento è effettuato con strumenti informatici e telematici, nel rispetto dei principi di liceità, correttezza, trasparenza, minimizzazione, esattezza, limitazione della conservazione, integrità e riservatezza. Il Titolare adotta misure tecniche e organizzative adeguate al rischio per prevenire accessi non autorizzati, perdita, distruzione, divulgazione o utilizzo illecito dei dati.
        </p>

        <h2>6. Destinatari dei dati</h2>
        <p>I dati personali possono essere trattati, nei limiti delle rispettive funzioni, da:</p>
        <ul>
          <li>personale e collaboratori autorizzati del Titolare;</li>
          <li>fornitori di hosting, infrastruttura, manutenzione, sicurezza informatica e backup;</li>
          <li>fornitori di posta elettronica e degli strumenti utilizzati per la gestione dei moduli e delle comunicazioni;</li>
          <li>consulenti legali, fiscali, organizzativi o tecnici;</li>
          <li>autorità pubbliche e soggetti ai quali la comunicazione sia imposta dalla legge.</li>
        </ul>
        <p>
          I soggetti che trattano dati per conto del Titolare sono designati responsabili del trattamento ai sensi dell'art. 28 GDPR, ove ne ricorrano i presupposti.
        </p>
        <p>
          I dati delle candidature non sono comunicati a terzi per autonome finalità commerciali senza uno specifico presupposto giuridico e un'adeguata informativa. L'eventuale trasmissione del profilo a etichette, produttori, partner o altri operatori del settore dovrà avvenire nei limiti della finalità professionale dichiarata e, quando necessario, previo consenso specifico dell'interessato.
        </p>

        <h2>7. Servizi esterni e trasferimenti verso Paesi terzi</h2>
        <p>
          I dati raccolti mediante i moduli sono conservati nell'infrastruttura e nel database indicati dal Titolare e dai relativi fornitori tecnici.
        </p>
        <p>
          Il sito può utilizzare risorse Google, quali Google Fonts e contenuti YouTube. Il caricamento di tali risorse può comportare la trasmissione a Google di dati tecnici, inclusi l'indirizzo IP e informazioni sul browser. I contenuti YouTube non necessari devono essere attivati solo dopo il consenso dell'utente, secondo quanto indicato nella Cookie Policy.
        </p>
        <p>
          Qualora un fornitore tratti dati fuori dallo Spazio economico europeo, il trasferimento sarà effettuato nel rispetto degli artt. 44 e seguenti GDPR, sulla base di una decisione di adeguatezza, delle clausole contrattuali standard o di altro strumento previsto dalla normativa applicabile.
        </p>

        <h2>8. Candidature di minorenni</h2>
        <p>
          Qualora il sito consenta candidature di persone di età inferiore a 18 anni, la candidatura deve essere presentata o autorizzata dal genitore o dal soggetto che esercita la responsabilità genitoriale. Il Titolare potrà richiedere le informazioni strettamente necessarie a verificare tale autorizzazione.
        </p>

        <h2>9. Processi decisionali automatizzati</h2>
        <p>
          Il Titolare non adotta decisioni basate unicamente su trattamenti automatizzati che producano effetti giuridici o incidano in modo analogo significativamente sull'interessato. La valutazione delle candidature è effettuata con intervento umano.
        </p>

        <h2>10. Diritti dell'interessato</h2>
        <p>
          L'interessato può esercitare, nei casi previsti dagli artt. 15-22 GDPR, i diritti di accesso, rettifica, cancellazione, limitazione del trattamento, portabilità dei dati e opposizione.
        </p>
        <p>
          Quando il trattamento si fonda sul consenso, l'interessato può revocarlo in qualsiasi momento. La revoca non pregiudica la liceità del trattamento effettuato prima della revoca. L'interessato può opporsi in qualsiasi momento al trattamento per finalità di marketing diretto, anche limitatamente a uno specifico canale di contatto.
        </p>
        <p>
          Le richieste possono essere inviate ai contatti indicati in epigrafe. Il Titolare potrà richiedere le informazioni necessarie a verificare l'identità del richiedente.
        </p>

        <h2>11. Reclamo e tutela giudiziaria</h2>
        <p>
          L'interessato che ritenga che il trattamento dei propri dati avvenga in violazione della normativa può proporre reclamo al Garante per la protezione dei dati personali ai sensi dell'art. 77 GDPR oppure rivolgersi all'autorità giudiziaria competente ai sensi dell'art. 79 GDPR.
        </p>

        <h2>12. Collegamenti e contenuti di terze parti</h2>
        <p>
          Il sito può contenere collegamenti a piattaforme social, siti di artisti, Spotify, YouTube, Instagram, Trustpilot o altri servizi esterni. Il Titolare non controlla i trattamenti effettuati dai gestori di tali piattaforme dopo il clic dell'utente. Si invita pertanto a consultare le relative informative privacy.
        </p>

        <h2>13. Modifiche all'informativa</h2>
        <p>
          La presente informativa può essere aggiornata in conseguenza di modifiche normative, organizzative o tecnologiche. La versione aggiornata sarà pubblicata sul sito con l'indicazione della data di ultimo aggiornamento.
        </p>
      </section>
    </div>
  );
}
